import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitInquiry = (data) => axios.post(`${API}/inquiries`, data);

export const uploadReference = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios.post(`${API}/uploads`, fd);
};

// ---------------------------------------------------------------- commerce
export const fetchProducts = () => axios.get(`${API}/products`);

export const createCheckout = (data) => axios.post(`${API}/orders/checkout`, data);

export const fetchOrderStatus = (sessionId) => axios.get(`${API}/orders/status/${sessionId}`);

export const fetchOnboarding = (token) => axios.get(`${API}/orders/onboard/${token}`);

export const submitOnboarding = (token, data) => axios.post(`${API}/orders/onboard/${token}`, data);

export const requestCancellation = (data) => axios.post(`${API}/cancellation/request`, data);

export const requestBuyout = (data) => axios.post(`${API}/buyout/request`, data);

// ------------------------------------------------------------------- admin
export const adminLogin = (data) => axios.post(`${API}/auth/login`, data, { withCredentials: true });

export const adminLogout = () => axios.post(`${API}/auth/logout`, {}, { withCredentials: true });

export const adminMe = () => axios.get(`${API}/auth/me`, { withCredentials: true });

export const adminFetchOrders = () => axios.get(`${API}/admin/orders`, { withCredentials: true });

export const adminPatchOrder = (id, patch) =>
  axios.patch(`${API}/admin/orders/${id}`, patch, { withCredentials: true });

export const adminFetchRequests = () => axios.get(`${API}/admin/requests`, { withCredentials: true });
